import { ExpandMore } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, To } from "react-router";

import { MapPanelHeader } from "~/modules/map/components/MapPanel";

type ReviewPlanHeaderProps = {
    backHref: To;
};

export function ReviewPlanHeader({ backHref }: ReviewPlanHeaderProps) {
    const { t } = useTranslation("plannerV2");

    return (
        <MapPanelHeader sx={{ justifyContent: "space-between" }}>
            <Typography flexGrow={1} variant="h6">
                {t("reviewPlanPanel.reviewAndPlan")}
            </Typography>
            <IconButton component={Link} to={backHref}>
                <ExpandMore />
            </IconButton>
        </MapPanelHeader>
    );
}
